import { createMessageStore } from "./MessageStore";

export const banMessageStore = createMessageStore();
